(function () {
  // ======================================================================
  // STORE LOCATOR
  // ----------------------------------------------------------------------
  // I dati stanno in assets/pq-sedi.json e NON in un metafield: il file
  // pesa 65,5 kB e il tetto di un metafield e' 64.
  // L'asset non ha limiti, il browser lo mette in cache, e aggiornarlo
  // significa caricare un file invece di incollare 65 kB in un campo
  // dell'admin.
  //
  // I campi sono abbreviati per contenere il peso:
  //   n nome | a indirizzo | c citta' | p paese | z cap | t telefono
  //   e email | w sito | h orari | lt lat | lg lng | k tipologie
  //   sl id sede Shopify (solo sui negozi diretti)
  //   pr priorita': 1 negozi Piquadro, 2 flag store, 3 rivenditori
  // ======================================================================

  var root = document.querySelector('[data-pq-locator]');
  if (!root) return;

  var urlDati = root.getAttribute('data-sedi');
  var chiaveMaps = root.getAttribute('data-maps-key');
  var sedi = [];
  var mappa = null;
  var marcatori = [];
  var centro = null;

  // Il marchio usato come marcatore per boutique e outlet.
  var MARCHIO = 'https://cdn.shopify.com/s/files/1/0616/7258/7444/files/favicon-black.png?v=1789475083';

  var elLista = root.querySelector('[data-pq-lista]');
  var elMappa = root.querySelector('[data-pq-mappa]');
  var elCerca = root.querySelector('[data-pq-cerca]');
  var elConta = root.querySelector('[data-pq-conta]');
  var elVuoto = root.querySelector('[data-pq-vuoto]');

  // --------------------------------------------------------------------
  // DISTANZA in chilometri con la formula dell'emisenoverso.
  // Si calcola in JavaScript sulle coordinate gia' nel file: nessuna
  // chiamata a Google per sede, solo una per tradurre cio' che l'utente
  // scrive in coordinate.
  // --------------------------------------------------------------------
  function distanza(lat1, lng1, lat2, lng2) {
    var R = 6371;
    var dLat = (lat2 - lat1) * Math.PI / 180;
    var dLng = (lng2 - lng1) * Math.PI / 180;
    var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
            Math.sin(dLng / 2) * Math.sin(dLng / 2);
    return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  }

  function filtriAttivi() {
    return [].slice.call(root.querySelectorAll('[data-pq-filtro]:checked'))
      .map(function (i) { return i.value; });
  }

  // --------------------------------------------------------------------
  // L'ORDINAMENTO tiene conto della priorita' SOLO a parita' di zona:
  // un negozio diretto a 400 km non deve precedere un rivenditore sotto
  // casa. La soglia di 15 km definisce "stessa zona".
  // Senza una ricerca attiva l'ordine e' per priorita' e poi alfabetico.
  // --------------------------------------------------------------------
  function ordina(a, b) {
    if (!centro) {
      if (a.pr !== b.pr) return a.pr - b.pr;
      return (a.c || '').localeCompare(b.c || '');
    }
    var fascia = Math.floor(a._d / 15) - Math.floor(b._d / 15);
    if (fascia !== 0) return fascia;
    if (a.pr !== b.pr) return a.pr - b.pr;
    return a._d - b._d;
  }

  function scheda(s) {
    var el = document.createElement('li');
    el.className = 'pq-sl__card pq-sl__card--' + (s.i || 'rivenditore');

    var righe = [];
    // L'etichetta distingue boutique da outlet: sono entrambi nostri ma
    // con assortimento e posizionamento diversi.
    if (s.i === 'boutique') righe.push('<span class="pq-sl__badge">Boutique Piquadro</span>');
    else if (s.i === 'outlet') righe.push('<span class="pq-sl__badge pq-sl__badge--outlet">Outlet Piquadro</span>');

    righe.push('<h3 class="pq-sl__card-name">' + escapa(nomeBreve(s.n)) + '</h3>');

    var ind = [s.a, s.a2].filter(Boolean).join(', ');
    var loc = [s.z, s.c].filter(Boolean).join(' ');
    righe.push('<p class="pq-sl__card-addr">' + escapa(ind) +
               (loc ? '<br>' + escapa(loc) : '') + '</p>');

    if (s.h) righe.push('<p class="pq-sl__card-hours">' + escapa(s.h) + '</p>');

    var azioni = [];
    if (s.t) {
      azioni.push('<a class="pq-sl__card-link" href="tel:' +
                  s.t.replace(/[^0-9+]/g, '') + '">' + escapa(s.t) + '</a>');
    }
    if (s.e) {
      azioni.push('<a class="pq-sl__card-link pq-sl__card-link--mail" href="mailto:' +
                  escapa(s.e.trim()) + '">' + escapa(s.e.trim()) + '</a>');
    }
    // Le indicazioni aprono Google Maps con le coordinate: piu' affidabile
    // dell'indirizzo, che su un centro commerciale porta al parcheggio
    // sbagliato.
    azioni.push('<a class="pq-sl__card-link" target="_blank" rel="noopener" href="https://www.google.com/maps/dir/?api=1&destination=' +
                s.lt + ',' + s.lg + '">Indicazioni</a>');
    if (s.w) {
      azioni.push('<a class="pq-sl__card-link" target="_blank" rel="noopener" href="' +
                  escapa(s.w) + '">Sito</a>');
    }
    righe.push('<div class="pq-sl__card-actions">' + azioni.join('') + '</div>');

    if (centro && s._d != null) {
      righe.push('<span class="pq-sl__card-dist">' +
                 (s._d < 1 ? Math.round(s._d * 1000) + ' m' : s._d.toFixed(1) + ' km') +
                 '</span>');
    }

    el.innerHTML = righe.join('');
    if (s.hd) el.setAttribute('data-hd', s.hd);
    el.addEventListener('click', function () { vaiA(s, el); });
    return el;
  }

  // Il contenuto della finestra informativa: stessa struttura delle
  // schede, cosi' passando dalla mappa all'elenco non si cambia alfabeto.
  // Sta in una funzione perche' serviva in due punti — il click sul
  // marcatore e il click sulla scheda — e duplicarlo significava
  // correggerlo due volte.
  function contenutoInfo(s) {
    var p = [];
    if (s.i === 'boutique') p.push('<span class="pq-sl__info-badge">Boutique Piquadro</span>');
    else if (s.i === 'outlet') p.push('<span class="pq-sl__info-badge pq-sl__info-badge--outlet">Outlet Piquadro</span>');

    p.push('<h4 class="pq-sl__info-name">' + escapa(nomeBreve(s.n)) + '</h4>');

    var ind = [s.a, s.a2].filter(Boolean).join(', ');
    var loc = [s.z, s.c].filter(Boolean).join(' ');
    p.push('<p class="pq-sl__info-addr">' + escapa(ind) +
           (loc ? '<br>' + escapa(loc) : '') + '</p>');

    if (s.h) p.push('<p class="pq-sl__info-hours">' + escapa(s.h) + '</p>');

    var az = [];
    if (s.t) {
      az.push('<a href="tel:' + s.t.replace(/[^0-9+]/g, '') + '">' + escapa(s.t) + '</a>');
    }
    if (s.e) {
      az.push('<a class="pq-sl__info-mail" href="mailto:' + escapa(s.e.trim()) + '">' + escapa(s.e.trim()) + '</a>');
    }
    az.push('<a target="_blank" rel="noopener" href="https://www.google.com/maps/dir/?api=1&destination=' +
            s.lt + ',' + s.lg + '">Indicazioni</a>');
    p.push('<div class="pq-sl__info-actions">' + az.join('') + '</div>');

    return '<div class="pq-sl__info">' + p.join('') + '</div>';
  }
  // Via l'insegna — Boutique, Outlet — che l'etichetta sopra dice gia',
  // e via il trattino che la separava dalla citta'.
  // Il marchio resta: "Piquadro Bologna, Piazza Maggiore".
  function nomeBreve(n) {
    return String(n || '')
      .replace(/^\s*(Boutique|Outlet)\s+(?=Piquadro)/i, '')
      .replace(/^(\s*Piquadro)\s*[—–-]+\s*/i, '$1 ')
      .replace(/\s+/g, ' ')
      .trim();
  }
  // escapa: i dati vengono da un file nostro, ma il markup si costruisce
  // per concatenazione e una virgoletta in un nome romperebbe l'HTML.
  function escapa(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;')
      .replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function disegna() {
    var f = filtriAttivi();
    // Il filtro legge il campo i — boutique, outlet, rivenditore — al
    // posto dell'array k con le cinque tipologie gestionali.
    // Una sede ha una sola insegna, quindi il confronto e' diretto invece
    // di cercare in un elenco.
    var visibili = sedi.filter(function (s) {
      if (!f.length) return true;
      return f.indexOf(s.i) > -1;
    });

    if (centro) {
      visibili.forEach(function (s) {
        s._d = distanza(centro.lat, centro.lng, s.lt, s.lg);
      });
      // Oltre i 150 km la ricerca non e' piu' utile: chi cerca "Milano"
      // non vuole un negozio a Napoli.
      visibili = visibili.filter(function (s) { return s._d <= 150; });
    }

    visibili.sort(ordina);
    // Senza ricerca si mostrano le prime 60: disegnare 416 schede
    // all'apertura costa e nessuno le scorre tutte.
    var mostrate = centro ? visibili : visibili.slice(0, 60);

    elLista.innerHTML = '';
    mostrate.forEach(function (s) { elLista.appendChild(scheda(s)); });

    if (elConta) {
      elConta.textContent = visibili.length + (visibili.length === 1 ? ' negozio' : ' negozi');
    }
    if (elVuoto) elVuoto.hidden = visibili.length > 0;

    aggiornaMarcatori(mostrate);
  }

  // --------------------------------------------------------------------
  // IL CLICK SU UNA SCHEDA: la mappa scorre, il marcatore rimbalza e la
  // scheda si marca come selezionata.
  // panTo e non setCenter: il primo anima lo spostamento, il secondo
  // salta. Lo zoom si cambia PRIMA dello spostamento, altrimenti
  // l'animazione parte da una scala diversa e si vede uno scatto.
  // --------------------------------------------------------------------
  function vaiA(s, card) {
    root.querySelectorAll('.pq-sl__card--attiva').forEach(function (c) {
      c.classList.remove('pq-sl__card--attiva');
    });
    if (card) card.classList.add('pq-sl__card--attiva');

    if (!mappa) return;
    if (mappa.getZoom() < 13) mappa.setZoom(14);
    mappa.panTo({ lat: s.lt, lng: s.lg });

    var m = marcatori.filter(function (x) { return x._sl === s; })[0];
    if (m) {
      // Il rimbalzo dura un secondo e mezzo: lasciarlo acceso stancherebbe
      // e coprirebbe i marcatori vicini.
      marcatori.forEach(function (x) { x.setAnimation(null); });
      m.setAnimation(google.maps.Animation.BOUNCE);
      setTimeout(function () { m.setAnimation(null); }, 1500);
      info.setContent(contenutoInfo(s));
      info.open(mappa, m);
    }

    // Su mobile la mappa sta sopra l'elenco: senza lo scorrimento il
    // movimento avviene fuori dalla vista.
    if (window.matchMedia('(max-width: 1023px)').matches) {
      elMappa.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }

  // --------------------------------------------------------------------
  // LINK DIRETTO A UN NEGOZIO: /pages/store-locator#<handle della sede>.
  // La mappa si centra sulla sede, l'elenco mostra i negozi vicini e la
  // sua scheda si apre come al click.
  // --------------------------------------------------------------------
  function apriDaHash() {
    var h = '';
    try { h = decodeURIComponent((location.hash || '').slice(1)); } catch (e) {}
    if (!h || !sedi.length) return;
    var s = sedi.filter(function (x) { return x.hd === h; })[0];
    if (!s) return;
    centro = { lat: s.lt, lng: s.lg };
    disegna();
    var card = null;
    [].slice.call(elLista.children).forEach(function (c) {
      if (c.getAttribute('data-hd') === h) card = c;
    });
    vaiA(s, card);
    if (card && card.scrollIntoView && !window.matchMedia('(max-width: 1023px)').matches) {
      card.scrollIntoView({ block: 'nearest' });
    }
  }
  window.addEventListener('hashchange', apriDaHash);

  function aggiornaMarcatori(elenco) {
    if (!mappa) return;
    marcatori.forEach(function (m) { m.setMap(null); });
    marcatori = [];
    var bounds = new google.maps.LatLngBounds();
    elenco.slice(0, 200).forEach(function (s) {
      // I NOSTRI negozi hanno il marchio, i rivenditori un pallino nero.
      // Il marchio si distingue a colpo d'occhio dal punto, quindi la
      // gerarchia si legge senza bisogno di colori diversi.
      // anchor al centro dell'immagine: senza, l'icona risulta spostata
      // rispetto alla coordinata reale.
      var nostro = s.i === 'boutique' || s.i === 'outlet';
      var icona = nostro
        ? {
            url: MARCHIO,
            scaledSize: new google.maps.Size(26, 26),
            anchor: new google.maps.Point(13, 13)
          }
        : {
            path: google.maps.SymbolPath.CIRCLE,
            scale: 4.5,
            fillColor: '#16161a',
            fillOpacity: 0.75,
            strokeColor: '#fff',
            strokeWeight: 1
          };

      var m = new google.maps.Marker({
        position: { lat: s.lt, lng: s.lg },
        map: mappa,
        title: s.n,
        zIndex: nostro ? 10 : 1,
        icon: icona
      });
      m._sl = s;
      m.addListener('click', function () {
      info.setContent(contenutoInfo(s));
        info.open(mappa, m);
      });
      marcatori.push(m);
      bounds.extend(m.getPosition());
    });
    if (marcatori.length) mappa.fitBounds(bounds, 40);
  }

  var info = null;

  // LO STILE DELLA MAPPA: i punti di interesse e i trasporti spariscono,
  // le strade restano ma smorzate. Su un locator la mappa serve a
  // collocare i negozi, e le etichette di Google competono con i nostri
  // marcatori.
  var stileMappa = [
    { featureType: 'poi', stylers: [{ visibility: 'off' }] },
    { featureType: 'transit', stylers: [{ visibility: 'off' }] },
    { featureType: 'road', elementType: 'labels', stylers: [{ visibility: 'simplified' }] },
    { featureType: 'water', stylers: [{ color: '#e9e9e7' }] },
    { featureType: 'landscape', stylers: [{ color: '#f7f6f4' }] },
    { featureType: 'road', elementType: 'geometry', stylers: [{ color: '#ffffff' }] },
    { featureType: 'administrative', elementType: 'labels.text.fill', stylers: [{ color: '#8c8880' }] }
  ];

  // Il callback di Google puo' scattare PRIMA o DOPO l'arrivo del JSON:
  // entrambi chiamano avvia, che procede solo quando ci sono tutte e due
  // le cose. Senza, la mappa nasceva vuota e le schede restavano senza
  // marcatori.
  var mapsPronto = false;
  var datiPronti = false;

  function avvia() {
    if (!mapsPronto || !datiPronti || mappa) return;
    info = new google.maps.InfoWindow();
    mappa = new google.maps.Map(elMappa, {
      center: { lat: 44.5, lng: 11.3 },
      zoom: 5,
      mapTypeControl: false,
      streetViewControl: false,
      fullscreenControl: false,
      styles: stileMappa
    });
    disegna();
    apriDaHash();
  }

  window.pqLocatorInit = function () {
    mapsPronto = true;
    avvia();
  };

  // --------------------------------------------------------------------
  // LA RICERCA usa il Geocoding di Google: una chiamata per ricerca, non
  // una per sede.
  // --------------------------------------------------------------------
  function cerca(testo) {
    if (!testo) { centro = null; disegna(); return; }
    if (typeof google === 'undefined') return;
    new google.maps.Geocoder().geocode({ address: testo }, function (res, stato) {
      if (stato === 'OK' && res[0]) {
        var p = res[0].geometry.location;
        centro = { lat: p.lat(), lng: p.lng() };
      } else {
        centro = null;
      }
      disegna();
    });
  }

  var form = root.querySelector('[data-pq-form]');
  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      cerca(elCerca.value.trim());
    });
  }

  var geoBtn = root.querySelector('[data-pq-geo]');
  if (geoBtn && navigator.geolocation) {
    geoBtn.addEventListener('click', function () {
      navigator.geolocation.getCurrentPosition(function (pos) {
        centro = { lat: pos.coords.latitude, lng: pos.coords.longitude };
        if (elCerca) elCerca.value = '';
        disegna();
      });
    });
  } else if (geoBtn) {
    geoBtn.hidden = true;
  }

  root.addEventListener('change', function (e) {
    if (e.target.matches('[data-pq-filtro]')) disegna();
  });

  var azzera = root.querySelector('[data-pq-azzera]');
  if (azzera) {
    azzera.addEventListener('click', function () {
      root.querySelectorAll('[data-pq-filtro]:checked').forEach(function (i) {
        i.checked = false;
      });
      if (elCerca) elCerca.value = '';
      centro = null;
      disegna();
    });
  }

  // --------------------------------------------------------------------
  // I DATI si caricano una volta e restano in cache del browser.
  // --------------------------------------------------------------------
  fetch(urlDati)
    .then(function (r) { return r.json(); })
    .then(function (d) {
      sedi = d.s || [];
      datiPronti = true;
      disegna();
      apriDaHash();
      // La guardia su window impedisce di iniettare lo script piu' volte:
      // misurati quattordici tag in pagina, e Google avvisa che caricare
      // la libreria piu' di una volta produce comportamenti imprevedibili
      // — compresa una mappa che non disegna nulla.
      if (chiaveMaps && typeof google === 'undefined' && !window.pqMapsCaricato) {
        window.pqMapsCaricato = true;
        var sc = document.createElement('script');
        sc.src = 'https://maps.googleapis.com/maps/api/js?key=' + chiaveMaps + '&callback=pqLocatorInit&loading=async';
        sc.async = true;
        document.head.appendChild(sc);
      } else if (typeof google !== 'undefined') {
        mapsPronto = true;
        avvia();
      }
    })
    .catch(function () {
      if (elVuoto) {
        elVuoto.hidden = false;
        elVuoto.textContent = 'Non riesco a caricare l\u2019elenco dei negozi.';
      }
    });
})();
